import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
// const { confirm } = Modal;
import { useLocation } from "react-router-dom";
import {
  CloseCircleOutlined,
  EyeOutlined,
  QuestionCircleOutlined,
  UserAddOutlined,
  UserDeleteOutlined,
} from "@ant-design/icons";
import { uuid } from "@ant-design/plots/es/utils";
import { Button, Dropdown, Space, Tag } from "antd";
import { DotVerticalIcon } from "assets/icons";
import moment from "moment/moment";
import CustomerForm from "pages/admin/customer/customerForm";
import {
  doDeleteCustomer,
  doGetCustomerPage,
  doUpdateCustomer,
  numOfEls,
} from "stores/slices/customer";
import { setIsRefresh } from "stores/slices/layout";

import AppButton from "components/button";
import ModalForm from "components/forms/components/modalForm";
import AppTable from "components/table";

import { OPT_TYPE, USER_TYPE } from "../../constants/appConstant";
import { AuthInfo } from "../../stores/slices/auth";
import { doGetAllCustomField } from "../../stores/slices/customField";

const CustomerTable = props => {
  const {
    isView,
    isOpenCustomerForm,
    setIsOpenCustomerForm,
    params,
    isAdd,
    setIsAdd,
    isDefault,
  } = props;

  console.log("isDefault", isDefault);
  const { state } = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const noOfElements = useSelector(numOfEls);
  const authInfo = useSelector(AuthInfo);

  const [isOpenViewCustomer, setIsOpenViewCustomer] = useState(false);
  const [customerSelected, setCustomerSelected] = useState(null);
  const [customFields, setCustomFields] = useState([]);

  const [searchParams, setSearchParams] = useState({
    sortFieldCustomer: "createdTime",
    sortDirection: "DESC",
    pageNumber: 1,
    pageSize: 10,
    broadcastListId: state?.broadcastListId,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isOpenModalRemoveCustomer, setIsOpenModalRemoveCustomer] =
    useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState();
  const [isOptoutCustomer, setIsOptoutCustomer] = useState(false);
  const [isOpenModalOptoutCustomer, setIsOpenModalOptoutCustomer] =
    useState(false);
  const [selectedOptoutCustomer, setSelectedOptoutCustomer] = useState();
  const [columns, setColumns] = useState([]);
  useEffect(() => {
    if (isAdd) {
      setCustomerSelected(null);
    }
  }, [isAdd]);

  useEffect(() => {
    if (params.id === "all") {
      dispatch(setIsRefresh(uuid()));
      if (authInfo?.type === USER_TYPE.SUPER_ADMIN) {
        setSearchParams({
          ...searchParams,
          broadcastListId: state?.broadcastListId,
        });
      }
    }
  }, [params, authInfo]);

  useEffect(() => {
    getListCustomField();
  }, []);

  const getListCustomField = async () => {
    if (authInfo.workspaceId || params.workspaceId) {
      const result = await dispatch(
        doGetAllCustomField(authInfo.workspaceId || params.workspaceId)
      );
      if (result) {
        setCustomFields(result.payload);
      }
    }
  };

  const handleFilter = (selectedKeys, confirm) => {
    confirm();
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
  };

  const handleTableChange = (pagination, filters, sorter) => {
    let newSearchParam = {};
    filters.firstName &&
      (newSearchParam = {
        ...newSearchParam,
        searchKeyFirstName: filters.firstName[0],
      });

    filters.lastName &&
      (newSearchParam = {
        ...newSearchParam,
        searchKeyLastName: filters.lastName[0],
      });

    filters.phoneNumber &&
      (newSearchParam = {
        ...newSearchParam,
        searchKeyPhoneNumber: filters.phoneNumber[0],
      });

    filters.status &&
      filters.status.indexOf(OPT_TYPE.OPTED_IN) !== -1 &&
      filters.status.indexOf(OPT_TYPE.OPTED_OUT) === -1 &&
      (newSearchParam = { ...newSearchParam, optin: true });
    filters.status &&
      filters.status.indexOf(OPT_TYPE.OPTED_IN) === -1 &&
      filters.status.indexOf(OPT_TYPE.OPTED_OUT) !== -1 &&
      (newSearchParam = { ...newSearchParam, optin: false });

    filters.optTime &&
      filters.optTime[0] &&
      (newSearchParam = {
        ...newSearchParam,
        fromDateTimeIn: moment(filters.optTime[0].toString()).format(
          "MM/DD/YYYY"
        ),
        fromDateTimeOut: moment(filters.optTime[0].toString()).format(
          "MM/DD/YYYY"
        ),
      });
    filters.optTime &&
      filters.optTime[1] &&
      (newSearchParam = {
        ...newSearchParam,
        toDateTimeIn: moment(filters.optTime[1].toString()).format(
          "MM/DD/YYYY"
        ),
        toDateTimeOut: moment(filters.optTime[1].toString()).format(
          "MM/DD/YYYY"
        ),
      });
    filters.workspaceName &&
      (newSearchParam = {
        ...newSearchParam,
        searchKeyWorkspaceName: filters.workspaceName[0],
      });

    if (sorter && sorter.columnKey && sorter.order) {
      newSearchParam = {
        ...newSearchParam,
        sortFieldCustomer: sorter.columnKey,
        sortDirection: sorter.order === "ascend" ? "ASC" : "DESC",
      };
    } else {
      newSearchParam = {
        ...newSearchParam,
        sortFieldCustomer: "createdTime",
        sortDirection: "DESC",
      };
    }

    newSearchParam = {
      ...newSearchParam,
      pageNumber: pagination.current,
      pageSize: pagination.pageSize,
    };

    setSearchParams(newSearchParam);
  };

  const handleFormatDateLocale = date => {
    const browserLocale = navigator.language;
    let dateLocale;
    if (date) {
      dateLocale = moment(date).utc().locale(browserLocale);
      return `${dateLocale.format("YYYY-MM-DD")}`;
    }
  };

  const showDeleteConfirm = data => {
    setSelectedCustomer(data);
    setIsOpenModalRemoveCustomer(true);
  };

  const handleRemoveCustomer = async () => {
    const request = {
      id: selectedCustomer.customerId,
    };
    if (params.id !== "all" && !isDefault) {
      request.broadcastListId = params.id;
    }
    const result = await dispatch(doDeleteCustomer(request));
    setIsLoading(false);
    setIsOpenModalRemoveCustomer(false);
    setSelectedCustomer();
    if (result && result.payload.status === 200) {
      if (searchParams.pageNumber > 1 && noOfElements === 1) {
        const newSearchParam = {
          ...searchParams,
          pageNumber: searchParams.pageNumber - 1,
        };
        setSearchParams(newSearchParam);
      }
      dispatch(setIsRefresh(uuid()));
    }
  };

  const actionOptionItems = record => {
    return [
      {
        key: "1",
        label: <span>{t("customer.viewAndEdit")}</span>,
        icon: <EyeOutlined style={{ fontSize: 20 }} />,
        onClick: () => {
          setCustomerSelected(record);
          setIsOpenViewCustomer(true);
          setIsOpenCustomerForm(true);
        },
      },
      {
        key: "2",
        danger: true,
        label: <span>{t("customer.optedOut")}</span>,
        icon: <CloseCircleOutlined style={{ fontSize: 20 }} />,
        disabled: record.broadcastListCustomer.optin === false,
        onClick: () => {
          setSelectedOptoutCustomer(record);
          setIsOpenModalOptoutCustomer(true);
        },
      },
      {
        key: "3",
        danger: true,
        label: <span>{t("customer.removeCustomer")}</span>,
        icon: <UserDeleteOutlined style={{ fontSize: 20 }} />,
        // disabled: record.broadcastListCustomer.optin === false,
        onClick: () => {
          showDeleteConfirm(record);
        },
      },
    ];
  };
  const handleTitleRemoveCustomer = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <QuestionCircleOutlined style={{ color: "red", fontSize: 24 }} />
        <span style={{ marginLeft: 10, fontSize: 16 }}>
          {t("customer.removeCustomer")}
        </span>
      </div>
    );
  };
  useEffect(() => {
    generatecolumns();
  }, []);

  const generatecolumns = () => {
    let cols = [];
    if (authInfo.type === USER_TYPE.SUPER_ADMIN) {
      cols = [
        {
          title: t("label.workspace"),
          width: 140,
          dataIndex: "workspaceName",
          key: "workspaceName",
          sorter: true,
          sortDirections: ["ascend", "descend"],
          isSearchable: true,
          searchPlaceholder:
            "Search by " + t("label.workspace").toString().toLowerCase(),
          ellipsis: {
            showTitle: false,
          },
          render: (_, { workspace }) => <>{workspace.name}</>,
        },
        {
          title: t("customer.firstName"),
          width: 120,
          dataIndex: "firstName",
          key: "firstName",
          sorter: true,
          isSearchable: true,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: t("customer.lastName"),
          width: 120,
          dataIndex: "lastName",
          key: "lastName",
          sorter: true,
          isSearchable: true,
          ellipsis: {
            showTitle: true,
          },
        },

        {
          title: t("customer.mobileNumber"),
          width: 100,
          dataIndex: ["contact", "phoneNumber"],
          key: "phoneNumber",
          sorter: true,
          isSearchable: true,
        },
        {
          title: t("customer.status"),
          width: 60,
          dataIndex: ["broadcastListCustomer", "optin"],
          key: "status",
          // sorter: true,
          filters: [
            {
              text: t("customer.optedIn"),
              value: OPT_TYPE.OPTED_IN,
            },
            {
              text: t("customer.optedOut"),
              value: OPT_TYPE.OPTED_OUT,
            },
          ],
          render: (_, record) => (
            <Tag
              color={
                record.broadcastListCustomer?.optin ? "#0E9154" : "#A9122B"
              }
              bordered={false}
            >
              {record.broadcastListCustomer?.optin
                ? t("customer.optedIn")
                : t("customer.optedOut")}
            </Tag>
          ),
        },
        {
          title: t("customer.updated"),
          width: 60,
          dataIndex: ["broadcastListCustomer"],
          key: "optTime",
          sorter: true,
          isFilterable: true,
          render: (_, record) => (
            <>
              {record.broadcastListCustomer?.optin
                ? handleFormatDateLocale(
                    record.broadcastListCustomer?.optinTime
                  )
                : handleFormatDateLocale(
                    record.broadcastListCustomer?.optoutTime
                  )}
            </>
          ),
        },
        {
          title: t("user.actions"),
          key: "actions",
          width: 50,
          render: (_, record) => {
            return (
              <>
                <Space size="middle">
                  <Dropdown
                    trigger={["click"]}
                    menu={{
                      items: actionOptionItems(record),
                    }}
                    placement="bottomRight"
                  >
                    <Button type="text" shape="circle" size="middle">
                      <DotVerticalIcon />
                    </Button>
                  </Dropdown>
                </Space>
              </>
            );
          },
        },
      ];
    } else {
      cols = [
        {
          title: t("customer.firstName"),
          width: 120,
          dataIndex: "firstName",
          key: "firstName",
          sorter: true,
          isSearchable: true,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: t("customer.lastName"),
          width: 120,
          dataIndex: "lastName",
          key: "lastName",
          sorter: true,
          isSearchable: true,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: t("customer.mobileNumber"),
          width: 100,
          dataIndex: ["contact", "phoneNumber"],
          key: "phoneNumber",
          sorter: true,
          isSearchable: true,
        },
        {
          title: t("customer.status"),
          width: 60,
          dataIndex: ["broadcastListCustomer", "optin"],
          key: "status",
          // sorter: true,
          filters: [
            {
              text: t("customer.optedIn"),
              value: OPT_TYPE.OPTED_IN,
            },
            {
              text: t("customer.optedOut"),
              value: OPT_TYPE.OPTED_OUT,
            },
          ],
          render: (_, record) => (
            <Tag
              color={
                record.broadcastListCustomer?.optin ? "#0E9154" : "#A9122B"
              }
              bordered={false}
            >
              {record.broadcastListCustomer?.optin
                ? t("customer.optedIn")
                : t("customer.optedOut")}
            </Tag>
          ),
        },
        {
          title: t("customer.updated"),
          width: 80,
          dataIndex: ["broadcastListCustomer"],
          key: "optTime",
          sorter: true,
          isFilterable: true,
          render: (_, record) => (
            <>
              {record.broadcastListCustomer?.optin
                ? handleFormatDateLocale(
                    record.broadcastListCustomer?.optinTime
                  )
                : handleFormatDateLocale(
                    record.broadcastListCustomer?.optoutTime
                  )}
            </>
          ),
        },
        {
          title: t("user.actions"),
          key: "actions",
          width: 40,
          render: (_, record) => {
            return (
              <>
                <Space size="middle">
                  <Dropdown
                    trigger={["click"]}
                    menu={{
                      items: actionOptionItems(record),
                    }}
                    placement="bottomRight"
                  >
                    <Button type="text" shape="circle" size="middle">
                      <DotVerticalIcon />
                    </Button>
                  </Dropdown>
                </Space>
              </>
            );
          },
        },
      ];
    }
    setColumns(cols);
  };

  const handleTitleOptoutCustomer = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <QuestionCircleOutlined style={{ color: "red", fontSize: 24 }} />
        <span style={{ marginLeft: 10, fontSize: 16 }}>
          {t("customer.optoutCustomer")}
        </span>
      </div>
    );
  };

  // const hanldeOptoutCustomer = async record => {
  //   const { payload } = await dispatch(
  //     doUpdateCustomer({
  //       data: {
  //         ...record,
  //         optin: false,
  //         workspaceId: record.workspace.id,
  //       },
  //       broadcastListId:
  //         authInfo?.type === USER_TYPE.SUPER_ADMIN
  //           ? record?.broadcastList?.id
  //           : !isDefault
  //           ? params.id
  //           : null,
  //       id: record.customerId,
  //     })
  //   );
  const hanldeOptoutCustomer = async record => {
    const { payload } = await dispatch(
      doUpdateCustomer({
        data: {
          ...record,
          optin: false,
          workspaceId: record.workspace.id,
        },
        broadcastListId:
          authInfo?.type === USER_TYPE.SUPER_ADMIN
            ? record?.broadcastList?.id
            : isDefault
            ? params.id
            : record?.broadcastList?.id,
        id: record.customerId,
      })
    );

    setIsOpenModalOptoutCustomer(false);
    setIsOptoutCustomer(false);
    setSelectedOptoutCustomer();
    if (payload) {
      dispatch(setIsRefresh(uuid()));
    }
  };
  return (
    <>
      <div style={{ height: "100%" }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "end",
            marginBottom: 24,
          }}
        >
          {!isView ? (
            <AppButton
              label={t("customer.addCustomer")}
              color={"primary"}
              type="primary"
              icon={<UserAddOutlined />}
              onClick={() => {
                setCustomerSelected(null);
                setIsOpenViewCustomer(false);
                setIsOpenCustomerForm(true);
                setIsAdd(true);
              }}
              style={customerStyles.buttonAdd}
            />
          ) : (
            <></>
          )}
        </div>
        <div>
          <AppTable
            searchParam={searchParams}
            api={
              params.id !== "all"
                ? doGetCustomerPage({
                    ...searchParams,
                    broadcastListId: params.id,
                  })
                : doGetCustomerPage(searchParams)
            }
            handleSearch={handleSearch}
            handleFilter={handleFilter}
            handleTableChange={handleTableChange}
            columns={columns}
            setSearchParam={setSearchParams}
          />
        </div>
        <ModalForm
          title={
            isOpenViewCustomer
              ? t("customer.viewCustomer")
              : customerSelected
              ? t("customer.updateCustomer")
              : t("customer.addCustomer")
          }
          onCancel={() => {
            setCustomerSelected(null);
            setIsOpenCustomerForm(false);
            setIsOpenViewCustomer(false);
            setIsAdd && setIsAdd(false);
          }}
          isOpen={isOpenCustomerForm}
          destroyOnClose={true}
          labelSubmit={t("label.save")}
          customWidth={700}
          footer={false}
          maskClosable={false}
        >
          <CustomerForm
            customerSelected={customerSelected}
            setCustomerSelected={setCustomerSelected}
            isOpenCustomerForm={isOpenCustomerForm}
            setIsOpenCustomerForm={setIsOpenCustomerForm}
            customFields={customFields}
            isView={isOpenViewCustomer}
            broadcastListId={params.id !== "all" ? params.id : ""}
            onChangeViewFrm={value => setIsOpenViewCustomer(value)}
            userType={authInfo?.type}
            workspaceObj={
              params?.workspaceId
                ? {
                    workspaceId: params.workspaceId,
                    workspaceName: params.workspaceName,
                  }
                : undefined
            }
            broadcastListObj={
              authInfo?.type === USER_TYPE.SUPER_ADMIN && params.id !== "all"
                ? {
                    broadcastListId: params.id,
                    broadcastListName: params.broadcastListName,
                  }
                : undefined
            }
          />
        </ModalForm>
        <ModalForm
          onCancel={() => {
            setIsOpenModalRemoveCustomer(false);
          }}
          isOpen={isOpenModalRemoveCustomer}
          title={handleTitleRemoveCustomer()}
          danger={true}
          maskClosable={false}
          footer={[
            <AppButton
              key="button"
              label={t("button.cancel")}
              color={"grey"}
              loading={isLoading}
              disabled={isLoading}
              htmlType="button"
              onClick={() => {
                setIsOpenModalRemoveCustomer(false);
              }}
            />,
            <AppButton
              key="button"
              color={"red"}
              label={t("button.remove")}
              loading={isLoading}
              disabled={isLoading}
              onClick={() => {
                setIsLoading(true);
                handleRemoveCustomer(selectedCustomer);
              }}
            />,
          ]}
        >
          <div style={{ height: 50, marginLeft: 35, fontSize: 14 }}>
            {t("text.removeCustomer")}
          </div>
        </ModalForm>

        <ModalForm
          onCancel={() => {
            setIsOpenModalOptoutCustomer(false);
          }}
          isOpen={isOpenModalOptoutCustomer}
          title={handleTitleOptoutCustomer()}
          danger={true}
          maskClosable={false}
          footer={[
            <AppButton
              key="button"
              label={t("button.no")}
              color={"grey"}
              loading={isOptoutCustomer}
              disabled={isOptoutCustomer}
              htmlType="button"
              onClick={() => {
                setIsOpenModalOptoutCustomer(false);
              }}
            />,
            <AppButton
              key="button"
              color={"red"}
              label={t("button.yes")}
              loading={isOptoutCustomer}
              disabled={isOptoutCustomer}
              onClick={() => {
                setIsOptoutCustomer(true);
                hanldeOptoutCustomer(selectedOptoutCustomer);
              }}
            />,
          ]}
        >
          <div style={{ height: 50, marginLeft: 35, fontSize: 14 }}>
            {t("text.optoutCustomer")}
          </div>
        </ModalForm>
      </div>
    </>
  );
};

const customerStyles = {
  buttonAdd: {
    minWidth: "auto",
    marginLeft: "10px",
  },
};
export default CustomerTable;
